import React, { useEffect } from 'react'

import './App.css';


export const Marquee = ({ mensaje }) => {

    useEffect(() => {
        if (!mensaje) return;
        const marqueeContent = document.querySelector('.marquee-content');
        if (!marqueeContent) return;

        // Calculate the width of the text content
        const contentWidth = marqueeContent.offsetWidth;

        // Set the animation duration based on the content width
        const animationDuration = (contentWidth / 50) + 10; // You can adjust the speed here

        // Apply the animation duration to the marquee content
        marqueeContent.style.animationDuration = `${animationDuration}s`;
    }, [mensaje]);

    if (!mensaje || !mensaje.trim()) return null;

    return (
        <div className="marquee-container">
            <div className="marquee-content">
                <span dangerouslySetInnerHTML={{ __html: mensaje }} />
            </div>
        </div>
    );
}
